import { Fragment, useState } from 'react'
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
} from '@headlessui/react'
import {
    Bars3Icon,
    ShoppingBagIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline'


const navigation = {
    categories: [
        {
            name: 'Bins',
            featured: [
                {
                    name: 'Order',
                    href: '/bins/',
                },
                {
                    name: 'FAQ',
                    href: '/FAQ#bins',
                },
            ],
        },
        {
            name: 'Storage Units',
            featured: [
                {
                    name: 'Order',
                    href: '/storage/',
                },
                {
                    name: 'FAQ',
                    href: '/FAQ#storage',
                },
            ],
        },
        {
            name: 'Vehicles',
            featured: [
                {
                    name: 'Order',
                    href: '/vehicles/',
                },
                {
                    name: 'FAQ',
                    href: '/FAQ#vehicles',
                },
            ],
        },
        {
            name: 'Golf Clubs',
            featured: [
                {
                    name: 'Order',
                    href: '/golf-clubs/',
                },
                {
                    name: 'FAQ',
                    href: '/FAQ#clubs',
                },
            ],
        },
        {
            name: 'Specialty Items',
            featured: [
                {
                    name: 'Order',
                    href: '/specialty/',
                },
                {
                    name: 'FAQ',
                    href: '/FAQ#spec',
                },
            ],
        },
    ],
    pages: [
        // { name: 'Contact', href: '/contact' },
        { name: 'FAQ', href: '/FAQ' },
        { name: 'Login', href: '/sign-in' },
    ],
}

export default function DemoNavigation() {
    const [open, setOpen] = useState(false)

    return (
        <div className="bg-white">
            {/* Mobile menu */}
            <Dialog open={open} onClose={setOpen} className="relative z-40 lg:hidden">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-black bg-opacity-25 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                />

                <div className="fixed inset-0 z-40 flex">
                    <DialogPanel
                        transition
                        className="relative flex w-full max-w-xs transform flex-col overflow-y-auto bg-white pb-12 shadow-xl transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                    >
                        <div className="flex px-4 pb-2 pt-5">
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                className="-m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400"
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                            </button>
                        </div>

                        {/* Links */}
                        {/* <TabGroup className="mt-2">
                            <div className="border-b border-gray-200">
                                <TabList className="-mb-px flex space-x-8 px-4">
                                    {navigation.categories.map((category) => (
                                        <Tab
                                            key={category.name}
                                            className="flex-1 whitespace-nowrap border-b-2 border-transparent px-1 py-4 text-base font-medium text-gray-900 data-[selected]:border-binz-blue data-[selected]:text-binz-blue"
                                        >
                                            {category.name}
                                        </Tab>
                                    ))}
                                </TabList>
                            </div>
                            <TabPanels as={Fragment}>
                                {navigation.categories.map((category) => (
                                    <TabPanel key={category.name} className="space-y-12 px-4 py-6">
                                        <div className="grid grid-cols-2 gap-x-4 gap-y-10">
                                            {category.featured.map((item) => (
                                                <div key={item.name} className="group relative">
                                                    <a href={item.href} className="mt-6 block text-sm font-medium text-gray-900">
                                                        <span aria-hidden="true" className="absolute inset-0 z-10" />
                                                        {item.name}
                                                    </a>
                                                    <p aria-hidden="true" className="mt-1 text-sm text-gray-500">
                                                        {category.name}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </TabPanel>
                                ))}
                            </TabPanels>
                        </TabGroup> */}

                        <div className="space-y-6 border-t border-gray-200 px-4 py-6 mt-24">
                            {navigation.categories.map((category) => (
                                <div key={category.name} className="px-4 py-6">
                                    <div className="grid grid-cols-2 gap-x-4 ">
                                        {category.featured.map((item, i) => {
                                            if (i > 0) return null
                                            return (

                                                <div key={item.name} className="group relative">
                                                    <a href={item.href} className="mt-0 block text-sm font-medium text-gray-900">
                                                        <span aria-hidden="true" className="absolute inset-0 z-10" />
                                                        {category.name}
                                                    </a>
                                                    <p aria-hidden="true" className="mt-1 text-sm text-gray-500">
                                                    </p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            ))}
                            {navigation.pages.map((page) => (
                                <div key={page.name} className="flow-root">
                                    <a href={page.href} className="-m-2 block p-2 font-medium text-gray-900">
                                        {page.name}
                                    </a>
                                </div>
                            ))}
                        </div>

                    </DialogPanel>
                </div>
            </Dialog>

            <header className="relative">
                <nav aria-label="Top">
                    {/* Top navigation */}
                    {/* Secondary navigation */}
                    <div className="bg-white">
                        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                            <div className="border-b border-gray-200">
                                <div className="flex h-32 items-center justify-between">
                                    {/* Logo (lg+) */}
                                    <div className="hidden lg:flex lg:flex-1 lg:items-center">
                                        <a href="/">
                                            <span className="sr-only">BINZ BINZ BINZ</span>
                                            <img
                                                alt=''
                                                src='/logo.png'
                                                className='h-max-16 w-auto lg:h-24'
                                            />
                                        </a>
                                    </div>

                                    <div className="hidden h-full lg:flex">
                                        {/* Flyout menus */}
                                        <PopoverGroup className="inset-x-0 bottom-0 px-12">
                                            <div className="flex h-full justify-center space-x-8">
                                                {navigation.categories.map((category) => (
                                                    <Popover key={category.name} className="flex">
                                                        <div className="relative flex">
                                                            <PopoverButton className="relative z-10 -mb-px flex items-center border-b-2 border-transparent pt-px text-sm font-medium text-gray-700 transition-colors duration-200 ease-out hover:text-gray-800 data-[open]:border-binz-blue data-[open]:text-binz-blue">
                                                                {category.name}
                                                            </PopoverButton>
                                                        </div>

                                                        <PopoverPanel
                                                            transition
                                                            className="absolute inset-x-0 top-full text-sm text-gray-500 transition data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                                                        >
                                                            {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
                                                            <div aria-hidden="true" className="absolute inset-0 top-1/2 bg-white shadow" />

                                                            <div className="relative bg-white">
                                                                <div className="mx-auto max-w-7xl px-8">
                                                                    <div className="grid grid-cols-2 gap-x-8 gap-y-10 py-8">
                                                                        {category.featured.map((item) => (
                                                                            <div key={item.name} className="group relative">
                                                                                <a href={item.href} className="mt-4 block font-medium text-gray-900 text-center">
                                                                                    <span aria-hidden="true" className="absolute inset-0 z-10" />
                                                                                    {item.name}
                                                                                </a>
                                                                                <p aria-hidden="true" className="mt-1 text-center">
                                                                                    {category.name}
                                                                                </p>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </PopoverPanel>
                                                    </Popover>
                                                ))}

                                                {navigation.pages.map((page) => (
                                                    <a
                                                        key={page.name}
                                                        href={page.href}
                                                        className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800"
                                                    >
                                                        {page.name}
                                                    </a>
                                                ))}
                                            </div>
                                        </PopoverGroup>
                                    </div>

                                    {/* Mobile menu and search (lg-) */}
                                    <div className="flex flex-1 items-center lg:hidden">
                                        <button
                                            type="button"
                                            onClick={() => setOpen(true)}
                                            className="-ml-2 rounded-md bg-white p-2 text-gray-400"
                                        >
                                            <span className="sr-only">Open menu</span>
                                            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
                                        </button>
                                    </div>

                                    {/* Logo (lg-) */}
                                    <a href="#" className="lg:hidden">
                                        <span className="sr-only">Your Company</span>
                                        <img
                                            alt=''
                                            src='/logo.png'
                                            className='h-16 w-auto lg:h-24'
                                        />
                                    </a>

                                    <div className="flex flex-1 items-center justify-end">
                                        <div className="flex items-center lg:ml-8">

                                            {/* Cart
                                            <div className="ml-4 flow-root lg:ml-8">
                                                <a href="#" className="group -m-2 flex items-center p-2">
                                                    <ShoppingBagIcon
                                                        aria-hidden="true"
                                                        className="h-6 w-6 shrink-0 text-gray-400 group-hover:text-gray-500"
                                                    />
                                                    <span className="ml-2 text-sm font-medium text-gray-700 group-hover:text-gray-800">0</span>
                                                    <span className="sr-only">items in cart, view bag</span>
                                                </a>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    )
}
